import { cn } from '@/lib/cn';
import { renderMarkdown } from '@/lib/markdown';
import type { JSX } from 'solid-js';

/** Sanitized GitHub-flavoured markdown (see lib/markdown). */
export const Markdown = (props: { source: string; class?: string }): JSX.Element => (
  <div class={cn('markdown', props.class)} innerHTML={renderMarkdown(props.source)} />
);
